{
  "activities": {
    "accessoryProvider": "配件供应商",
    "accessoryRawMaterialProvider": "原材料供应商",
    "apparel": {
      "duvet": {
        "baffle": "隔热层",
        "farm": "繁殖",
        "materialProduction": "原材料",
        "preProcessor": "预处理器"
      },
      "fabric": {
        "appret": "整理",
        "coating": "涂层",
        "dyeing": "染色/印花",
        "lamination": "层压",
        "materialProduction": "原材料",
        "spinning": "纺纱",
        "weavingKnitting": "织造/编织"
      },
      "leather": {
        "appret": "整理",
        "dyeing": "染色",
        "farm": "农场",
        "materialProduction": "屠宰场",
        "tanning": "鞣制"
      },
      "manufacturing": "制造商",
      "yarn": {
        "dyeing": "染色",
        "materialProduction": "原材料",
        "spinning": "纺纱"
      }
    },
    "brand": "品牌",
    "certifiedEntity": "认证实体",
    "footwear": {
      "assembling": "组装",
      "finishing": "整理",
      "stitching": "缝制"
    },
    "noActivity": "noActivity",
    "paper": {
      "assembling": "组装",
      "bleaching": "漂白",
      "chemicalTreatment": "化学处理",
      "laminating": "层压",
      "manufacturing": "制造",
      "pressing": "压合",
      "printing": "印刷",
      "resineRemoving": "去树脂",
      "whiteWashing": "水洗漂白"
    },
    "product": {
      "productWashing": "产品洗涤",
      "washing": "洗涤"
    },
    "wood": {
      "assembling": "组装",
      "brushing": "刷光",
      "calibrationAndCollage": "校准与拼贴",
      "harvesting": "采伐",
      "manufacturing": "制造",
      "materialDrying": "干燥",
      "materialPeeking": "分选",
      "materialPeeling": "剥皮",
      "materialSawing": "锯切",
      "sanding": "打磨"
    }
  },
  "batchModal": {
    "actions": {
      "selectEmpty": "仅选择空的"
    },
    "applyButton": "将 {{type}} 应用于 {{ itemCount }} 个项目",
    "batchUpdateSuccess": "更新成功",
    "batchUpdateSuccessMessage_one": "1 条信息请求已更新",
    "batchUpdateSuccessMessage_many": "{{count}} 条信息请求已更新",
    "batchUpdateSuccessMessage_other": "{{count}} 条信息请求已更新",
    "info": "有 <b>{{count}}</b> 个其他项目具有活动 <b><activity/><b>",
    "labels": {
      "certificate": "证书",
      "clientName": "客户名称",
      "componentName": "组件名称",
      "componentReference": "组件参考",
      "contact": "联系人",
      "documentProof": "证书",
      "informationRequestItemReference": "请求参考",
      "informationRequestItemReferenceHint": "这是指与信息请求相关的项目参考（例如，产品、材料或组件参考）",
      "materialName": "材料名称",
      "materialProportion": "材料比例",
      "materialReference": "材料参考",
      "productCollection": "产品系列",
      "productColor": "产品颜色",
      "productId": "产品ID",
      "productionSite": "生产地点",
      "productName": "产品名称",
      "productReference": "产品参考",
      "purchaseOrder": "采购订单",
      "purchaseOrderRef": "采购订单",
      "reference": "参考"
    },
    "noDocument": "没有证书",
    "searchProduct": "搜索产品",
    "title": "将此操作应用于多个项目？"
  },
  "batchPopover": {
    "button": "批量更新...",
    "certificateText": "将此证书应用于多个请求？",
    "text": "将此{{key}}应用于多个<b><activity /></b>?"
  },
  "certificateBatchModal": {
    "labels": {
      "certificate": "证书",
      "products": "产品",
      "type": "类型"
    },
    "success_other": "{{count}} 证书请求已更新"
  },
  "certificateRequestStatus": {
    "ACCEPTED": "已接受",
    "OPENED": "已打开",
    "REJECTED": "已拒绝",
    "SUBMITTED": "待处理"
  },
  "certificates": {
    "actions": {
      "delete": "删除",
      "submit": "提交",
      "transfer": "转移"
    },
    "activityName": "溯源步骤",
    "labels": {
      "maxIssueDate": "最大发行日期",
      "purchaseOrder": "采购订单或发票号码"
    },
    "modal": {
      "areyousure": "您确定要删除此证书吗（此操作不可逆）？",
      "no": "否",
      "yes": "是，删除"
    },
    "noRequests": {
      "closed": "无完成的证书请求",
      "open": "无待处理的证书请求"
    },
    "productionSite": "生产地点",
    "productionSitePending": "生产地点信息待处理",
    "purchaseOrder": {
      "actions": {
        "seeLess": "隐藏产品",
        "seeMore": "显示产品"
      },
      "productReferences": "产品参考"
    },
    "reference": "参考: {{reference}}",
    "select": {
      "placeholder": "从您上传的文件中选择一份文档。"
    },
    "upload": {
      "title": "上传证书"
    }
  },
  "contactModal": {
    "labels": {
      "companyCity": "公司城市",
      "companyCityPlaceholder": "巴黎",
      "companyCityTooltip": "公司城市",
      "companyCountry": "公司国家",
      "companyCountryTooltip": "公司国家",
      "companyIsActive": "Active",
      "companyIsActivePlaceholder": "Active",
      "companyIsActiveTooltip": "Identify business partners currently active and available for trade.",
      "companyName": "公司名称",
      "companyNamePlaceholder": "公司名称",
      "companyNameTooltip": "公司名称",
      "companyPostalCode": "公司邮政编码",
      "companyPostalCodePlaceholder": "75001",
      "companyPostalCodeTooltip": "公司邮政编码",
      "companyRegistrationId": "Company registration ID",
      "companyRegistrationIdDescription": {
        "DUNS": "Unique 9-digit identifier issued by Dun & Bradstreet, commonly used in the US and for international trade. Format: 9-digit numeric code.",
        "EORI": "Identification number for businesses involved in EU customs activities. Format: country code (e.g., FR) + 14-digit SIRET number.",
        "GLN": "Global Location Number - unique identifier for company locations or legal entities under GS1 standard. Format: 13-digit numeric code.",
        "OTHER": "Unique identifier of the company",
        "RCS": "RCS (numéro du registre du commerce): RCS + city + SIREN.",
        "VAT": "European tax identification number for companies liable to VAT. Format: country code (e.g., FR) + 2-digit key + 9-digit SIREN number."
      },
      "companyRegistrationIdPlaceholder": "1234567890",
      "companyRegistrationIdTooltip": "公司注册ID",
      "companyRelationshipType": {
        "AGENT": "代理",
        "BRAND": "品牌",
        "MANUFACTURER": "制造商",
        "OTHER": "其他",
        "RAW_MATERIAL_SUPPLIER": "原材料供应商",
        "SUPPLIER": "供应商",
        "TRADER": "贸易商"
      },
      "companyRelationshipTypeName": "类型",
      "companyRelationshipTypeTooltip": "合作伙伴公司的性质，用于确定其在供应链中的角色。",
      "companyStreet": "公司街道",
      "companyStreetPlaceholder": "里沃利街1号",
      "companyStreetTooltip": "公司街道",
      "companySupplierCode": "公司供应商代码",
      "companySupplierCodePlaceholder": "1234567890",
      "companySupplierCodeTooltip": "Short internal identification code for the business partner.",
      "contactInformation": "contactInformation",
      "coordinates": "coordinates",
      "coordinatesPlaceholder": "coordinatesPlaceholder",
      "email": "电子邮件地址",
      "emailPlaceholder": "johndoe@gmail.com",
      "emailTooltip": "用于联系公司合作伙伴的电子邮件地址",
      "name": "姓名",
      "namePlaceholder": "约翰·多伊",
      "nameTooltip": "用于通过电子邮件交换的合作伙伴的常用标识",
      "preferredLanguage": "首选语言",
      "tags": "标签",
      "tagsPlaceholder": "添加标签...",
      "tagsTooltip": "内部分类、评分或任何其他上下文信息。"
    },
    "messages": {
      "create": {
        "error": "error",
        "success": "success"
      },
      "update": {
        "success": "success"
      }
    }
  },
  "contactSelect": {
    "labels": {
      "addNewContact": "添加新联系人",
      "contact": "联系人",
      "you": "您"
    },
    "placeholders": {
      "contact": "搜索联系人"
    }
  },
  "contactTable": {
    "columns": {
      "activity": {
        "name": "活动",
        "tooltip": "合作伙伴的最后一次登录。"
      },
      "averageResponseTime": {
        "averageResponseTimeValue_one": "{{nbDays}} 天",
        "averageResponseTimeValue_other": "{{nbDays}} 天",
        "name": "平均响应时间",
        "tooltip": "平均响应时间。"
      },
      "certificateRequests": {
        "name": "证书请求"
      },
      "code": {
        "name": "代码",
        "tooltip": "商业伙伴的简短内部识别代码。"
      },
      "company": {
        "name": "公司",
        "tooltip": "商业伙伴公司的官方公开名称。"
      },
      "contactEmail": {
        "name": "联系人（邮件）",
        "tooltip": "合作伙伴公司内主要联系人的电子邮件。"
      },
      "contactName": {
        "name": "联系人（姓名）",
        "tooltip": "合作伙伴公司内主要联系人的姓名。"
      },
      "location": {
        "name": "位置",
        "tooltip": "商业伙伴公司的国家"
      },
      "productionSiteRequests": {
        "name": "生产站点请求",
        "received": "已接收"
      },
      "productionSites": {
        "name": "生产站点",
        "tooltip": "商业伙伴声明的站点数量和不同国家的数量。"
      },
      "productRequests": {
        "name": "产品请求"
      },
      "reminder": {
        "name": "提醒",
        "tooltip": "合作伙伴的最后一次提醒。"
      },
      "requests": {
        "name": "请求",
        "tooltip": "合作伙伴回复的请求。"
      },
      "status": {
        "name": "状态",
        "tooltip": "识别当前活跃且可用于贸易的商业伙伴。"
      },
      "tags": {
        "name": "标签",
        "tooltip": "内部分类、评级或任何其他上下文信息。"
      },
      "type": {
        "name": "类型",
        "tooltip": "合作伙伴公司的性质，用于确定其在供应链中的角色。"
      }
    },
    "status": {
      "active": "活跃",
      "inactive": "非活跃"
    }
  },
  "customFields": {
    "attachment": "附件",
    "updateCustomField": {
      "customField": {
        "message": "自定义字段值已更新并发送给客户",
        "title": "自定义字段值已更新"
      },
      "customFieldProof": {
        "message": "自定义字段证书已上传",
        "title": "自定义字段证书已上传"
      }
    },
    "uploadCustomFieldProofTooltip": "请求数字证书以支持提供的值"
  },
  "deselectAll": "取消全部选择",
  "errors": {
    "axiosMessage": "发生以下错误：{{message}} \n\n 请重试，若错误仍然存在，请联系 support@traceforgood.com",
    "reinforcedTraceability": "您不能将此请求分配给自己，请将其转移给相关人员",
    "title": "发生错误"
  },
  "filters": {
    "client": "客户",
    "search": "搜索",
    "status": {
      "canceled": "已取消",
      "closed": "已关闭",
      "opened": "已打开",
      "placeholder": "状态"
    },
    "title": "筛选器",
    "type": "类型"
  },
  "item": {
    "brand": "品牌",
    "client": "客户",
    "collection": "系列",
    "color": "颜色",
    "component": "组件",
    "date": "采购订单日期",
    "marketLaunchDate": "上市日期",
    "material_one": "材料",
    "material_other": "材料",
    "name": "名称",
    "partOf": "部分属于",
    "product": "产品",
    "purchaseOrderRef": "采购订单",
    "reference": "引用",
    "type": "类型"
  },
  "itemType": {
    "component": "组件",
    "material": "材料",
    "product": "产品"
  },
  "launch": {
    "modal": {
      "cancel": {
        "button": "button",
        "no": "no",
        "title": "title",
        "yes": "yes"
      },
      "close": {
        "button": "button"
      },
      "eligibleProducts": {
        "checkbox": "checkbox",
        "error": {
          "title": "title"
        },
        "infoBox": {
          "description": {
            "multiple": "multiple",
            "single": "single"
          },
          "title": {
            "multiple": "multiple",
            "single": "single"
          }
        },
        "launchButton": {
          "label": {
            "multiple": "multiple",
            "none": "none",
            "single": "single"
          }
        }
      },
      "fullTraceability": {
        "infoBox": {
          "description": "description",
          "title": "title"
        }
      },
      "header": {
        "description": {
          "default": "default",
          "noTraceabilityCampaign": "noTraceabilityCampaign",
          "runningJob": "runningJob"
        },
        "title": "title"
      },
      "pendingProducts": {
        "infoBox": {
          "description": {
            "multiple": "multiple",
            "single": "single"
          },
          "title": {
            "multiple": "multiple",
            "single": "single"
          }
        }
      },
      "success": {
        "button": "button",
        "description": "description",
        "title": "title"
      }
    }
  },
  "maxError": "必须小于或等于{{max}}",
  "minError": "必须大于或等于{{min}}",
  "operation": {
    "component": "组件",
    "duplicateProductionSite": "虽然提交仍然可能，但请注意该站点已声明其他步骤。",
    "material": "材料",
    "notOwner": "信息已由{{email}}提供",
    "product": "产品",
    "purchaseOrderRef": "采购订单引用",
    "reference": "供应商的{{type}}引用",
    "unknown": "另一个联系人"
  },
  "operationNotCreated": "发生错误",
  "operationNotCreatedMessage": "此请求的信息请求尚未创建，请联系support@traceforgood.com",
  "prodsiterequest": {
    "actions": {
      "transfer": "转移到另一个联系人",
      "transferAll": "全部转移"
    },
    "noRequests": {
      "closed": "您没有完成的请求。",
      "open": "您没有待处理的请求。"
    },
    "status": {
      "INVALID": "不完整",
      "TOBESUBMITTED": "准备提交"
    },
    "transferModal": {
      "success_one": "{{count}} 个生产站点请求值成功转移",
      "success_many": "{{count}} 个生产站点请求值成功转移",
      "success_other": "{{count}} 个生产站点请求值成功转移",
      "title": "转移生产站点请求",
      "transferButton": "转移"
    }
  },
  "productionSiteSelect": {
    "labels": {
      "addNewProductionSite": "添加新的生产地点",
      "productionSite": "生产地点"
    },
    "placeholders": {
      "productionSite": "搜索生产地点"
    }
  },
  "reopenRequest": {
    "error": "重新打开请求失败",
    "feedback_one": "已取消 {{count}} 个子请求",
    "feedback_other": "已取消 {{count}} 个子请求",
    "title": "您确定要重新打开此请求吗？（此操作将取消此请求的所有子请求）",
    "yes": "是的，我确定！"
  },
  "request": {
    "complete": "提交",
    "completeTooltip": "点击此处以完成并关闭请求。任何已转移的子请求将被转发给指定的接收人。",
    "errors": {
      "generic": "发生错误。请稍后再试。"
    },
    "incomplete": "不完整",
    "labels": {
      "composition": "组成",
      "requestDate": "请求日期"
    },
    "readyToSubmit": "准备提交",
    "seeLess": "隐藏请求",
    "seeMore": "显示请求"
  },
  "requests": {
    "noRequests": {
      "closed": "您尚未关闭任何请求。",
      "open": "您没有待处理的请求等待您的操作。"
    },
    "tabs": {
      "canceled": "canceled",
      "certificates": {
        "scope": "范围证书",
        "transaction": "交易证书"
      },
      "closed": "已完成",
      "prodsitefield": "生产地点请求",
      "traceability": "溯源请求"
    }
  },
  "requiredError": "必填字段",
  "selectAll": "全选",
  "sorts": {
    "client": "客户",
    "dueDate": "截止日期",
    "orderDate": "订单日期",
    "receptionDate": "请求日期",
    "reference": "参考"
  },
  "status": {
    "NOT_UPLOADED": "",
    "PROCESSED": "已处理",
    "REJECTED": "",
    "UPLOADED": "已处理"
  },
  "submitModal": {
    "composition": "组成",
    "confidenceStatement": "我在此郑重声明所提供的信息是正确而完整的",
    "confirmation_one": "{{count}} 溯源请求已成功提交",
    "confirmation_other": "{{count}} 溯源请求已成功提交",
    "error": "错误",
    "noRequests": "您没有要提交的完成请求，请检查其他页面",
    "reference": "引用",
    "submitButton": "确认（{{ itemCount }}）",
    "title": "选择要提交的所有请求",
    "type": "类型"
  },
  "supplierSettings": {
    "filters": {
      "productionSite": "productionSite",
      "status": "状态",
      "tags": "标签"
    }
  },
  "tooltips": {
    "contact": "提供信息的联系人",
    "productionSite": "一个注册的生产地点，用于生产或加工。每个地点通常与一个生产流程相关联，除非与多个操作集成。",
    "purchaseOrderRef": "如果您没有此{{type}}的采购订单，您可以提供发票号码",
    "reference": "用于识别您的供应商的产品、组件或材料"
  },
  "transferModal": {
    "success": "证书请求转移成功",
    "title": "选择要转移证书的联系人"
  },
  "uniqueActivitiesLabels": {
    "accessoryProvider": "配件供应商",
    "accessoryRawMaterialProvider": "原材料供应商",
    "apparel": {
      "duvet": {
        "baffle": "隔热层",
        "farm": "农场（羽绒）",
        "materialProduction": "原材料（羽绒）",
        "preProcessor": "预处理器"
      },
      "fabric": {
        "appret": "整理（面料）",
        "coating": "涂层（面料）",
        "dyeing": "染色/印花（面料）",
        "lamination": "层压",
        "materialProduction": "原材料（面料）",
        "spinning": "纺纱（面料）",
        "weavingKnitting": "织造/编织"
      },
      "leather": {
        "appret": "整理（皮革）",
        "dyeing": "染色（皮革）",
        "farm": "农场（皮革）",
        "materialProduction": "屠宰场",
        "tanning": "皮革鞣制"
      },
      "manufacturing": "服装制造",
      "yarn": {
        "dyeing": "染色（纱线）",
        "materialProduction": "原材料（纱线）",
        "spinning": "纺纱（纱线）"
      }
    },
    "brand": "品牌",
    "certifiedEntity": "认证实体",
    "footwear": {
      "assembling": "组装",
      "finishing": "整理",
      "stitching": "缝制"
    },
    "noActivity": "noActivity",
    "paper": {
      "assembling": "纸张组装",
      "bleaching": "漂白",
      "chemicalTreatment": "化学处理",
      "laminating": "层压",
      "manufacturing": "纸张制造",
      "pressing": "压合",
      "printing": "印刷",
      "resineRemoving": "去树脂",
      "whiteWashing": "水洗漂白"
    },
    "product": {
      "productWashing": "产品洗涤",
      "washing": "洗涤"
    },
    "wood": {
      "assembling": "木材组装",
      "brushing": "刷光",
      "calibrationAndCollage": "校准与拼贴",
      "harvesting": "采伐",
      "manufacturing": "木材制造",
      "materialDrying": "干燥",
      "materialPeeking": "分选",
      "materialPeeling": "剥皮",
      "materialSawing": "锯切",
      "sanding": "打磨"
    }
  }
}
